import React from 'react';
import PropTypes from 'prop-types';

import SmallLogoBlack from '~IMAGES/logos/responsive-black.svg';
import SmallLogoWhite from '~IMAGES/logos/responsive-white.svg';
import LargeLogoBlack from '~IMAGES/logos/nameplate-black.svg';
import LargeLogoWhite from '~IMAGES/logos/nameplate-white.svg';

const smallLogoStyles = 'smallLogo d-lg-h';
const largeLogoStyles = 'largeLogo d-sm-h d-lg-ib';

const GamedayLogo = ({ isLight }) => {
  const logo = isLight ? (
    <>
      <img alt='gameday logo small' src={SmallLogoWhite} className={smallLogoStyles} />
      <img alt='gameday logo large' src={LargeLogoWhite} className={largeLogoStyles} />
    </>
  ) : (
    <>
      <img alt='gameday logo small' src={SmallLogoBlack} className={smallLogoStyles} />
      <img alt='gameday logo large' src={LargeLogoBlack} className={largeLogoStyles} />
    </>
  );
  return (
    <div className='flex-container center' aria-label={`${import.meta.env.VITE_APP_NAME}`}>
      {logo}
    </div>
  );
};

GamedayLogo.defaultProps = {
  isLight: false
};

GamedayLogo.propTypes = {
  isLight: PropTypes.bool
};

export default GamedayLogo;
